<template>
    <div class="rules">
        <div @click="rule">
            <img :src="`${img}rule.png`" alt="" class="img" />
        </div>
        <div @click="change('tel:'+tel)">
            <img :src="`${img}tel.png`" alt="" class="img"  />
        </div>
        <div @click="change('https://h5.zzqz2024.com/pages/lhhy/equity')">
            <img :src="`${img}get.png`" alt="" class="img"
                 />
        </div>

    </div>
</template>

<script>
import { traceApi } from '@/api/index.js'  // 导入命名导出
export default {
    name: "Right",
    data() {
        return {

        };
    },
    methods: {

     point(e, n) {
    // 获取 traceId，增加容错（避免 null/undefined）
    const traceId = localStorage.getItem('traceId') || '';
    // 返回接口请求的 Promise
    return traceApi.event({
        t: traceId,
        e: e,
        f: n // 若 n 无传参，此处会是 undefined，可根据接口要求处理（比如设为空字符串）
    }).then((res) => {
        // 可选：接口成功后的额外逻辑（如日志、埋点成功统计）
        console.log('埋点上报成功', res);
        return res; // 透传结果
    }).catch((err) => {
        // 关键：接口失败时也要 catch，避免阻断跳转
        console.error('埋点上报失败', err);
        // 失败仍返回 resolved 的 Promise，保证跳转能执行
        return Promise.resolve(err);
    });
},

// 跳转方法（async 标记为异步函数）
async change(item) {
    try {
        // 等待埋点接口执行完成（无论成功/失败）
        if (item === 'https://h5.zzqz2024.com/pages/lhhy/equity') {
            await this.point(8); // 等待 e=8 的埋点完成
        } else {
            await this.point(7); // 等待 e=7 的埋点完成
        }
        // 埋点完成后再跳转
        window.location.href = item;
    } catch (err) {
        // 极端异常兜底：确保即使代码出错也能跳转
        console.error('跳转前逻辑异常', err);
        window.location.href = item;
    }
},
        rule() {

            this.$emit('rule', true)
        }
    },
    props: {
        img: String,//图片地址
        tel: String
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img {
    width: 22px;
    z-index: 2;
    margin-top: 12px;
}

.rules {
    position: fixed;
    display: flex;
    z-index: 2;
    right: 0;
    flex-direction: column;
    top: 122px;
}
</style>
